import React from "react";
import { Header } from '../../../Components/Layout/Header.jsx';
import { ObavijestiCasino } from '../../../Components/Layout/ObavijestiCasino.jsx';
import { MetaTags } from '../../../Components/Layout/MetaTags.jsx';

export default function VipPage(props) {
    return (
        <>
            <MetaTags title="VIP Igrači | Postani dio Ekskluzivnog Casino Kluba | SuperCasino" description="VIP SuperSport Casino!" />
            <Header key="header" {...props} />
            <div className="vip-page">
                <img className="header" src="Content/Images/Vip/bg_1.png" alt="Banner" />
                <img className="lines" src="Content/Images/Vip/img_linija_gore_sredina.png" alt="Line" />
                <img className="lines1" src="Content/Images/Vip/img_linija_gore_sredina.png" alt="Line" />
                <div className="banner">
                    <img className="crown" src="Content/Images/Vip/gold_crown.png" alt="Crown" />
                    <img className="super-casino" src="Content/Images/Vip/logo_supercasino.png" alt="SuperCasino" />
                    <img className="vip" src="Content/Images/Vip/VIP_optimized.gif" alt="Vip" />

                    <p className="text-1">Postani dio ekskluzivnog kluba SuperCasino igrača i ostvari pravo na posebne nagrade, bonuse i poklone za VIP članove.</p>
                    <img className="separator" src="Content/Images/Vip/yellow_separator.png" alt="Separator" />
                    <img className="stand" src="Content/Images/Vip/stand1.png" alt="Stand" />
                    <img className="overlay-img" src="Content/Images/Vip/rectangle_overlay.png" alt="Fade overlay " />
                </div>
                <section className="section-1">
                    <div className="block">
                        <img className="lik" src="Content/Images/Vip/lik.png" alt="Lik" />
                        <img className="hand" src="Content/Images/Vip/ruka.png" alt="Hand" />
                        <img className="shoe" src="Content/Images/Vip/cipela.png" alt="Shoe" />
                        <h2 className="title-1" >Tvoj VIP manager</h2>
                        <p className="text-info">Svakom VIP igraču dodijeljen je VIP&nbsp;manager - osoba koja se brine da je zabava zajamčena i neometana. VIP&nbsp;manager je dostupan u svakom trenutku ako imaš nekih nejasnoća, pitanja ili zahtjeva.</p>
                    </div>
                    <div className="block">
                        <img className="mail" src="Content/Images/Vip/mail.png" alt="Mail" />
                        <img className="bell" src="Content/Images/Vip/bell.png" alt="Bell" />
                        <h2 className="title-2">Premium e-mail podrška</h2>
                        <p className="text-info">VIP igrači imaju dediciranu e-mail podršku. To znači da su tvoji upiti prioritet i naš tim će se instantno posvetiti pronalasku rješenja u najkraćem mogućem roku.</p>
                    </div>
                    <div className="block">
                        <img className="kruzici" src="Content/Images/Vip/kruzici.png" alt="Kruzici" />
                        <img className="krivulja" src="Content/Images/Vip/krivulja.png" alt="Krivulja" />
                        <img className="zvono" src="Content/Images/Vip/zvono.png" alt="Zvono" />
                        <img className="kugla" src="Content/Images/Vip/kugla.png" alt="Kugla" />
                        <h2 className="title-3">Direktan pristup posebnim promocijama</h2>
                        <p className="text-info">Kao dio ekskluzivnog kluba VIP igrača imaš direktan pristup posebnim SuperCasino i SuperPoker promocijama i događajima.</p>
                    </div>
                    <div className="block">
                        <img className="rucka" src="Content/Images/Vip/drska.png" alt="Rucka" />
                        <img className="kofer" src="Content/Images/Vip/kofer.png" alt="Kofer" />
                        <img className="avion" src="Content/Images/Vip/avioncic.png" alt="Avion" />
                        <h2 className="title-4">Posebni paketi za odmor i putovanja</h2>
                        <p className="text-info">SuperCasino je u suradnji sa svojim partnerima pripremio posebne pakete za odmor i putovanja za svoje najvjernije VIP korisnike. Uživajte u tjednim i mjesečnim pogodnostima samo kao VIP član.</p>
                    </div>
                    <div className="big-block">
                        <img className="bonus" src="Content/Images/Vip/bonus.png" alt="Lid" />
                        <img className="bonus1" src="Content/Images/Vip/bonus1.png" alt="Box" />
                        <h2 className="title-5">
                            Jedinstvene pogodnosti
                            <br />i nagrade samo
                            <br />za tebe</h2>
                        <p className="text-5">Uz postojeće promocije i bonuse, VIP igrači imaju unikatne i personalizirane pogodnosti. Trudimo se pratiti tvoju igru i ponuditi ono što najviše voliš.</p>
                        <div className="benefits-container">
                            <div className="benefits">
                                <img className="separator" src="Content/Images/Vip/short_separator.png" alt="Separator" />
                                <p>Rođendanski poklon bon</p>
                            </div>
                            <div className="benefits">
                                <img className="separator" src="Content/Images/Vip/short_separator.png" alt="Separator" />
                                <p>Posebni tjedni i mjesečni bonusi</p>
                            </div>
                            <div className="benefits">
                                <img className="separator" src="Content/Images/Vip/short_separator.png" alt="Separator" />
                                <p>Posebni paketi za odmor i putovanja</p>
                            </div>
                            <div className="benefits">
                                <img className="separator" src="Content/Images/Vip/short_separator.png" alt="Separator" />
                                <p>Besplatne ulaznice za utakmice</p>
                            </div>
                            <div className="benefits">
                                <img className="separator" src="Content/Images/Vip/short_separator.png" alt="Separator" />
                                <p>Posebni blagdanski pokloni</p>
                            </div>
                            {/*<div className="benefits">*/}
                            {/*    <img className="separator" src="Content/Images/Vip/short_separator.png" alt="Separator" />*/}
                            {/*    <p>VIP Gold korisnička značka</p>*/}
                            {/*</div>*/}
                        </div>
                    </div>
                </section>
                <section className="section-2">
                    <img className="red-seat" src="Content/Images/Vip/red-seat.png" alt="Red seat" />
                    <div className="circle"></div>
                    <h1>Kako postati VIP&nbsp;član?</h1>
                    <div className="block">
                        <img src="Content/Images/Vip/ic_play.png" alt="Play" />
                        <h2>Samo igraj dalje</h2>
                        <p>Naš VIP tim svakodnevno prati tvoju igru. Na tebi je samo da se i dalje trudiš i igraš što bolje možeš. Sigurni smo da će ti se trud isplatiti!</p>
                    </div>
                    <div className="block">
                        <img src="Content/Images/Vip/ic_heart.png" alt="Heart" />
                        <h2>Nagrađujemo vjernost</h2>
                        <p>Budi svakodnevan gost SuperCasina i time ćeš si povećati izglede da postaneš član našeg VIP kluba.</p>
                    </div>
                    <div className="block">
                        <img src="Content/Images/Vip/ic_flex.png" alt="Flex" />
                        <h2>Budi uporan</h2>
                        <p>Sudjeluj u različitim funkcionalnostima SuperCasina poput promocija, utrka, turnira te igraj nove i raznolike igre svih providera.</p>
                    </div>
                    <div className="block">
                        <img src="Content/Images/Vip/ic_mask.png" alt="Mask" />
                        <h2>Aktivnost se isplati</h2>
                        <p>Postani istaknuti član SuperCasina. Sudjeluj u komunikaciji s igračima i našom podrškom i pomozi u stvaranju što boljeg igračkog iskustva.</p>
                    </div>
                    {props?.user ? <button onClick={() => location.href = 'https://mcasino.supersport.hr/'}>ZAIGRAJ</button> : <button onClick={() => location.href = 'https://m.supersport.hr/registracija/'}>REGISTRIRAJ SE</button>}
                    <div className="character-container">
                        <img className="body" src="Content/Images/Vip/body.png" alt="Vip user" />
                        <img className="left-hand" src="Content/Images/Vip/left-hand.png" alt="Vip user" />
                        <img className="right-hand" src="Content/Images/Vip/right-hand.png" alt="Vip user" />
                        <img className="coins" src="Content/Images/Vip/coins.png" alt="Vip user" />
                    </div>
                </section>
                <section className="section-3">
                    <h2>Posljednje iz ponude za VIP&nbsp;igrače</h2>
                    <div className="item">
                        <img src="Content/Images/Vip/img_placeholder6.png" alt="Poklon vikend" />
                        <h3>Boca pića</h3>
                        <p>Sadrži više od 50 vrsta pića između kojih možeš odabrati svoje omiljeno.</p>
                    </div>
                    <div className="item">
                        <img src="Content/Images/Vip/img_placeholder7.png" alt="Poklon vikend" />
                        <h3>Karte za utakmice</h3>
                        <p>Uživajte u predstavi Vaših omiljenih igrača SuperSport HNL.</p>
                    </div>
                    <div className="item">
                        <img src="Content/Images/Vip/img_placeholder4.png" alt="Poklon vikend" />
                        <h3>Ulaznice za koncerte</h3>
                        <p>Uživaj u odličnoj glazbi jer SuperCasino će te odvesti na koncert tvojeg omiljenog pjevača ili pjevačice.</p>
                    </div>
                    <div className="item">
                        <img src="Content/Images/Vip/img_placeholder5.png" alt="Poklon vikend" />
                        <h3>Festivali i događaji</h3>
                        <p>U blizini se održava festival ili događaj? Reci gdje želiš ići i SuperCasino te vodi u nezaboravan super provod!</p>
                    </div>
                    <div className="item">
                        <img src="Content/Images/Vip/img_placeholder.png" alt="Poklon vikend" />
                        <h3>Poklon Vikend iz snova</h3>
                        <p>Poklon Vikend iz snova sadrži više od 100 lokacija za nezaboravan doživljaj u luksuznom ambijentu. Omogućuje smještaj u romantičnom i luksuznom ambijentu hotela, apartmana ili vila.</p>
                    </div>
                    <div className="item">
                        <img src="Content/Images/Vip/img_placeholder1.png" alt="Harmonija ljepote" />
                        <h3>Poklon Harmonija ljepote</h3>
                        <p>Poklon Harmonija ljepote sadrži više od 70 lokacija za njegu, ljepotu i opuštanje. Omogućuje posjet luksuznim wellness-centrima i kozmetičkim salonima. Vidimo se!</p>
                    </div>
                    <div className="item">
                        <img src="Content/Images/Vip/img_placeholder2.png" alt="Ekstravagantna večera" />
                        <h3>Ekstravagantna večera</h3>
                        <p>Poklon Ekstravagantna večera sadrži više od 80 lokacija za ekstravagantne gurmanske doživljaje. Paket Ekstravagantna večera omogućuje večeru od 3 i više slijeda hrane.</p>
                    </div>
                    <div className="item">
                        <img src="Content/Images/Vip/img_placeholder3.png" alt="Poklon XXL Extreme" />
                        <h3>Poklon XXL Extreme</h3>
                        <p>Poklon XXL Extreme sadrži više od 40 lokacija za ekstremne doživljaje i sportske aktivnosti. Adrenalinski parkovi u prirodi, paragliding let i avionom, vožnja go-karta, itd.</p>
                    </div>
                </section>
            </div>
            <ObavijestiCasino {...props}></ObavijestiCasino>
        </>
    );
}